import { useMemo } from 'react';
import { Box } from '@rsos/components/capstone/base';
import { ChatComponentType, useChatComponents } from '../useChatComponents';
import AgencyShareChatBox from './AgencyShareChat/ASCChatBox';
import { ChatContextProvider } from './ChatContext';
import CollaboratorChatbox from './CollaboratorChatBox/CollaboratorChatbox';
import ConversationsChatBox from './ConversationsChatBox/ConversationsChatbox';
import RcsChatBox from './RcsChatBox/RcsChatBox';
import TF911ChatBox from './TF911ChatBox/TF911ChatBox';

const CallChats = () => {
  const {
    chatComponentType,
    shouldRenderAgencyShareChat,
    shouldRenderCollaboratorChat,
  } = useChatComponents();

  const chatComponent = useMemo(() => {
    if (chatComponentType === ChatComponentType.Conversations) {
      // All future sources should lead to here
      return (
        <ChatContextProvider chatType="conversations">
          <ConversationsChatBox />
        </ChatContextProvider>
      );
    }

    if (chatComponentType === ChatComponentType.RCS) {
      // Free TF911 module (Google RCS or Standard SMS)
      return (
        <ChatContextProvider chatType="rcs">
          <RcsChatBox />
        </ChatContextProvider>
      );
    }

    if (chatComponentType === ChatComponentType.TF911) {
      // Base TF911
      return (
        <ChatContextProvider chatType="textFrom911">
          <TF911ChatBox />
        </ChatContextProvider>
      );
    }

    return null;
  }, [chatComponentType]);

  return (
    <Box data-name="call-chats" height="100%" overflowY="auto" gridRowGap="8px">
      {chatComponent}
      {shouldRenderCollaboratorChat && (
        <ChatContextProvider chatType="collaborator">
          <CollaboratorChatbox />
        </ChatContextProvider>
      )}
      {shouldRenderAgencyShareChat && (
        <ChatContextProvider chatType="agencyShare">
          <AgencyShareChatBox />
        </ChatContextProvider>
      )}
    </Box>
  );
};

export default CallChats;
